<template>
  <div class="fixed-plugin" v-click-outside="closeDropDown">
    <div class="dropdown show-dropdown" :class="{ show: isOpen }">
      <a data-toggle="dropdown">
        <i class="fa fa-cog fa-2x" @click="toggleDropDown"></i>
      </a>
      <ul class="dropdown-menu" :class="{ show: isOpen }">
        <li class="header-title">{{$lang.titles.settings}}</li>
        <li class="adjustments-line sidebar-mini">
          {{$lang.keys.edit_mode}}
          <md-switch :value="!editButton" @change="val => updateSettings(val)"></md-switch>
        </li>

        <li class="adjustments-line button-container">
          <md-button class="md-info md-block md-fileinput">
              <template>{{$lang.keys.change_map}}</template>
              <input type="file" @change="changeMap($event)" accept="image/*" />
            </md-button>
        </li>

        <li class="header-title" v-show="editButton">{{$lang.titles.new_switch}}</li>

        <li class="text-center" style="width: 100%;" v-show="editButton">
          <md-field :class="[{ 'md-error': errors.has('DEVICE_SELECT') }]">
            <label>{{$lang.inputs.device_select}}</label>
            <md-select
              v-model="newButton.deviceMAC"
              name="DEVICE_SELECT"
              id="DEVICE_SELECT"
              data-vv-name="DEVICE_SELECT"
              v-validate="modelValidations.required"
            >
              <md-option
                v-for="(item, key) in devices"
                :key="key"
                :value="item.name"
                @click.native="onChangeDisconnector(item.relays)"
              >{{item.name}}</md-option>
            </md-select>
          </md-field>
        </li>

        <li class="text-center" style="width: 100%;" v-show="editButton">
          <md-field :class="[{ 'md-error': errors.has('RELAY_SELECT') }]">
            <label>{{$lang.inputs.relay_select}}</label>
            <md-select
              v-model="newButton.relay"
              name="RELAY_SELECT"
              id="RELAY_SELECT"
              data-vv-name="RELAY_SELECT"
              v-validate="modelValidations.required"
              :disabled="deviceRelays.length == 0"
            >
              <md-option
                v-for="(relay, key) in deviceRelays"
                :key="key"
                :value="relay.value"
              >{{relay.name}}</md-option>
            </md-select>
          </md-field>
        </li>

        <li class="button-container" v-show="editButton">
          <md-button class="md-success md-block" target="_blank" @click="createButton">{{$lang.keys.create_swich}}</md-button>
        </li>

        <!-- <li class="header-title">{{$lang.titles.map}}</li>

        <div class="md-layout">
          <div class="md-layout-item md-size-100">
            <md-button class="md-primary md-round md-block md-fileinput">
              <template>{{$lang.keys.change_map}}</template>
              <input type="file" @change="changeMap($event)" accept="image/*" />
            </md-button>
          </div>
          <div class="md-layout-item md-size-50">
            <md-button class="md-danger md-round md-block" @click="deleteMap">{{$lang.keys.delete}}</md-button>
          </div> 
        </div>-->
      </ul>
    </div>
  </div>
</template>

<script>
import { SlideYDownTransition } from "vue2-transitions";

export default {
  components: {
    SlideYDownTransition
  },

  props: {
    devices: {
      type: Array,
      default: []
    },
    editMode: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      modelValidations: {
        button_name: {
          required: true,
          max: 30,
          min: 3
        },
        required: {
          required: true
        }
      },
      isOpen: false,
      editButton: false,
      newButton: {
        name: ""
      },
      deviceRelays: []
    };
  },

  mounted() {
    this.editButton = this.editMode;
  },

  methods: {
    toggleDropDown() {
      this.isOpen = !this.isOpen;
    },

    closeDropDown() {
      this.isOpen = false;
    },

    onChangeDisconnector(relays) {
      this.deviceRelays = relays;
    },

    createButton() {
      this.$validator.validateAll().then(res => {
        if (res) {
          const relayIndex = this.deviceRelays.findIndex(
            relay => relay.value === this.newButton.relay
          );

          if (relayIndex !== -1) {
            this.newButton.name = this.deviceRelays[relayIndex].name.substring(
              4
            );

            this.$emit("on-new-button", this.newButton);

            this.deviceRelays = this.deviceRelays.filter(
              el => el.value !== this.newButton.relay
            );

            this.newButton.relay = "";
            this.newButton.name = "";
            this.newButton.deviceMAC = "";
            this.deviceRelays = [];

            this.$validator.reset();
          }
        }
      });
    },

    deleteMap() {
      this.$emit("on-delete", true);
    },

    changeMap(event) {
      this.$emit("on-change", event);
    },

    updateSettings(val) {
      this.editButton = val;
      this.$emit("update:editable", val);
    }
  }
};
</script>

<style lang="scss">
.md-menu-content.md-select-menu {
  z-index: 11000;
}
</style>

<style scoped>
.fixed-plugin {
  top: 150px;
}
.centered-row {
  display: flex;
  height: 100%;
  align-items: center;
}

.button-container .btn {
  margin-right: 10px;
}

.centered-buttons {
  display: flex;
  justify-content: center;
}
</style>
